<template>
  <div id="flyNavControl" v-if='showSelf' :style="panelStyle">
     <div class="basicControls-title">模拟飞行</div>
      <div class="panel-car">
            <div class="panel-car-top">
                 <span class="car-item-small" @click="slowNav">
                     <i class="iconfont icon-jiansu-"></i>
                 </span>
                 <span class="car-item-small" @click='playNav'>
                     <i class="iconfont icon-kaishi-" v-if="player=='play'"></i>
                     <i class="iconfont icon-zanting-" v-if="player=='pause'"></i>
                 </span>
                 <span class="car-item-small" @click='acceNav'>
                     <span class="iconfont icon-qianjin"></span>
                 </span>
                 <span class="car-item-small" @click='stopNav'>
                     <i class="iconfont icon-tingzhi"></i>
                 </span>
                 <div class="car-item-big speed">
                    {{flySpeed}}
                 </div>
            </div>
            <div class="panel-car-top">
                 <span class="car-item-small" @click="upHeight">
                     <i class="iconfont icon-shangsheng-tianchong"></i>
                 </span>
                 <span class="car-item-small" @click='downHeight'>
                     <span class="iconfont icon-xiajiang_huaban"></span>
                 </span>
                 <div class="car-item-big speed">
                    {{flyHeight}}m
                 </div>
            </div>
            <!-- <div class="panel-bottom" @click="">
                 退出模拟驾驶
            </div> -->
        </div>
  </div>
</template>
<script>
   import {FlyNavControlCommand} from './commands/FlyNavControlCommand.js'
export default {
  data: function() {
    return {
      flySpeed:20,
      flyHeight:50,
      player:'play',
      showSelf:false,
      panelStyle: 'top:70px;right:15px;', 
      playIcon: '/static/bimroad/imgs/player_play.png'
    }
  },
  methods: {
    adjStyle : function(style){
        this.panelStyle=  style;
   },

    //0-stop 1-playOrResume 2-acc 3-deacce
    stopNav : function(){
        var eventArg = {'command': new FlyNavControlCommand(0, this)};
        this.$emit("controlFlyCommand", eventArg);
        // this.showSelf = false;
    },
    upHeight : function(){
      var eventArg = {'command': new FlyNavControlCommand(4, this)};
      this.$emit("controlFlyCommand", eventArg);
    },
    downHeight : function(){
      var eventArg = {'command': new FlyNavControlCommand(5, this)};
      this.$emit("controlFlyCommand", eventArg);
    },
    slowNav : function(){
      var eventArg = {'command': new FlyNavControlCommand(3, this)};
      this.$emit("controlFlyCommand", eventArg);
    },
    acceNav : function(){
      var eventArg = {'command': new FlyNavControlCommand(2, this)};
      this.$emit("controlFlyCommand", eventArg);
    },
    playNav : function(){
      var eventArg = {'command': new FlyNavControlCommand(1, this)};
      this.$emit("controlFlyCommand", eventArg);
    },
  }
}
</script>
<style lang='less' scoped>
  @import '../../assets/css/mixin.less';
  #flyNavControl{
        position:absolute;
        width: 248px;
        box-sizing: border-box;
        border: 1px solid #14171c;
        background: linear-gradient(0deg,#1e202a,#0d1013);
        box-shadow: inset 0 0 0 1px #575757, 0 2px 21px 0 rgba(33,34,39,.55);
        opacity: .85;
        border-radius: 2px;
        color: #fff;
        z-index:200;
        .sc(14px,#fff);
        .basicControls-title{
          .wh(100%,40px);
          line-height:40px;
          text-align: center;
          border-bottom:1px dotted #505050;
        }
       .panel-car{
             width: 248px;
            .panel-car-top{
                padding:9px 13px;
                display:flex;
                align-items:center;
                .car-item-small{
                   .wh(30px,30px);
                   background-color: #fff;
                   display:flex;
                   align-items:center;
                   justify-content:center;
                   margin-right:13px;
                   border-radius:50%;
                   cursor:pointer;
                   color:#51515d;
                   &:hover{
                      color:#3970F0;
                   }
                   .icon-qianjin{
                      font-size:14px;
                      margin-left:2px;
                   }
                   .icon-kaishi-{
                      font-size:18px;
                      margin-left:-3px;
                   }
                   .icon-jiansu-{
                      margin-right:2px;
                   }
                   .icon-tingzhi{

                   }
                   .icon-shangsheng-tianchong{
                      font-size:20px;
                   }
                   .icon-xiajiang_huaban{
                      font-size:20px;
                   }
                }
                .car-item-big{
                    .wh(40px,40px);
                    background-color: #fff;
                   display:flex;
                   align-items:center;
                   justify-content:center;
                   
                   border-radius:50%;
                   
                   color:#51515d;
                }
                .speed{
                    background-size:cover;
                    background-repeat:no-repeat;
                    background-position:center center;
                    background-image:url('/static/bimroad/imgs/Speedcard.png');
                }
                .car-view{
                    cursor:pointer;
                    margin-right:13px;
                    &:hover{
                      color:#3970F0;
                    }
                    .icon-moxing{
                        font-size:22px;
                    }
                }
            }
            .panel-bottom{
                .wh(100%,35px);
                line-height:35px;
                .sc(14px,#fff);
                text-align: center;
                border-top:1px solid #696d80;
                cursor:pointer;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/plugins/components/Web3dModels/FlyControlPanel.vue